// ---------------------------------------------------------------------------
// Game configuration (set by the host when creating a lobby)
// ---------------------------------------------------------------------------

export type GameMode = "ffa" | "lms" | "teams" | "ctf";
/** How CTF is scored. "deliver" = bring an enemy flag into your own base for a
 *  capture; "conquest" = hold enemy flags at your base for points/second over
 *  time; "carry" = a tank earns points/second for every enemy flag it personally
 *  carries (flags never sit at a base — they only drop when their carrier dies). */
export type CtfScoreMode = "deliver" | "conquest" | "carry";
export const CTF_SCORE_MODES: CtfScoreMode[] = ["deliver", "conquest", "carry"];
/** How a flag can change hands by touch (besides being dropped on a kill).
 *  "any" = anyone who touches the carrier takes it; "team" = only teammates
 *  (relay) — enemies must kill the carrier; "off" = only a kill drops it. */
export type FlagStealMode = "any" | "team" | "off";
export const FLAG_STEAL_MODES: FlagStealMode[] = ["any", "team", "off"];
export type WallStyle =
  | "maze"
  | "sparse"
  | "open"
  | "cross" // a plus-shaped wall through the center
  | "lshape" // an L-shaped wall at the center
  | "tunnels" // Nokia-snake: vertical bars with staggered gaps
  | "box" // Nokia-snake: an inner room with doorways
  | "dots"; // Nokia-snake: a regular field of short pillars
export const WALL_STYLES: WallStyle[] = [
  "maze",
  "sparse",
  "open",
  "cross",
  "lshape",
  "tunnels",
  "box",
  "dots",
];
export type MapSize = "small" | "normal" | "large" | "random";

/** Pickup types. "speed"/"shield" are buffs; the rest change your shot. */
export type PowerupType =
  | "speed"
  | "shield"
  | "sniper"
  | "explosive"
  | "laser"
  | "tracking"
  | "multishot"
  | "rapidfire"
  | "scope";
